module.exports = "<p>\n  system-activity works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Dashboard/DashboardPages/system-activity/system-activity.component.html
// module id = ./src/app/Dashboard/DashboardPages/system-activity/system-activity.component.html
// module chunks = main